module.exports = __webpack_public_path__ + "static/media/service_03.52652528.webp";